<template>

  <section class="section mobile_div section_bg"
        >
    <loading-block v-if="is_load==false && is_load_error==false" :loading="!is_load"/>
    <div class="container-fluid" v-if="is_load==false && is_load_error==true">
      <div class="alert alert-warning">
        <h2>Ошибка</h2>
        <p>{{ load_error}}</p>
      </div>

    </div>
    <div class="container-fluid mobile_div" v-if="is_load">


        <div class="container mobile_div   ">
          <div class="live__scroll m-0 container mobile_div row section_header  mt-2 mb-2">
            <div class="col-sm-4 mt-2 mb-2" v-if="funnels" v-for="(funnel,funnel_key) in funnels">
              <router-link tag="a" class="btn " :to="{name: 'funnel', params: { id: funnel.last_id }}">
                {{ funnel.title}}
              </router-link>
            </div>
          </div>


          <div class="col-12 m-4 d-flex justify-content-center">

            <router-link tag="a" class="btn btn-second" :to="{name: 'leadtasks'}">
              задачи
            </router-link>
          </div>
          <div class="col-12 m-4 d-flex justify-content-center">


           <router-link tag="a" class="btn btn-second" :to="{name: 'add_lead'}">
              <i class="fa fa-plus"></i> сделку
            </router-link>
          </div>

          <div class="second_section pt-2 pb-2">
            <h2 class="text-center mt-2 mb-2">Все сделки</h2>


            <div class="row m-4 ">
              <div class="col-12 col-lg-8 mb-2">
                <input type="text" class="form-control" v-model="q"/>
              </div>
              <div class="col-lg-4 col-12 mb-2">
                <button type="submit" class="btn" @click="searchLeads">Найти</button>
              </div>
            </div>
          </div>

        <div class="alert alert-warning" v-if="leads.length==0">
          <h4>Ничего не найдено</h4>
        </div>
        <div class="card mt-2 section_gray_bg lead_card"  v-if="leads.length>0 && is_load==true" v-for="(lead,lead_key) in leads">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="card-title">ID Лида:  #{{lead.id}}</h5>
              <h6 class="card-subtitle mb-2 text-muted">Дата добавления: {{ lead.created_at}}</h6>
              <h6 class="card-subtitle mb-2 text-muted">Дата обновления: {{ lead.updated_at}}</h6>
              <p class="card-text">Воронка:<router-link tag="a" :to="{name: 'funnel', params: { id: lead.funnel.last_id }}">
                {{ lead.funnel.title}}
              </router-link></p>
              <p class="card-text">Статус: {{ lead.status.title }}</p>
              <p class="card-text"  v-if="lead.tags && lead.tags.length>0"
              >Теги:<b v-for="(tag,tag_index) in lead.tags" :key="tag_index">
                #<router-link tag="a" :to="{name: 'leads', query: { q: tag }}">
                {{tag}}
              </router-link>&nbsp;</b>
              </p>
            </div>

            <div class="col-sm-6">
              <h5 class="card-title">Информация о лиде:</h5>
              <p class="card-text" v-if=" lead.lead_data[c_field.name]" v-for="c_field in custom_fields"><i class="fa fa-phone-square " v-if="c_field.type=='phone'"></i> <i class="fa fa-vk" v-if="c_field.type=='vk'"></i> <i class="fa fa-address-book-o" v-if="c_field.type=='email'"></i> {{ c_field.title}}: <a v-if="c_field.type=='vk'" target="_blank" :href="lead.lead_data[c_field.name]" >{{ lead.lead_data[c_field.name] }}</a> <b v-if="c_field.type!='vk'">{{ lead.lead_data[c_field.name] }}</b></p>

              <router-link tag="a"  :to="{name: 'lead', params: { id: lead.id }}">
                Открыть сделку
              </router-link>
            </div>
          </div>


        </div>
        <div v-if="leads.length>0 && leads.length<count">
          <button v-if="isappending==false" @click="appendLeads()" class="btn">Загрузить еще</button>
          <h2 v-if="isappending">Идет загрузка...</h2>
        </div>








      </div>

    </div>
  </section>


</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "@/models/Api";
import Modal from "@/components/Modal";
import vueKanban from 'vue-kanban'
import itemTemplate from '@/components/itemTemplate.vue';
import LoadingBlock from "@/components/Custom/LoadingBlock";


export default {
  name: "home",

  data() {

    var app = this;

    return {
      items:[],
      leads: [],
      is_load:false,
      is_load_error:false,
      load_error:'',
      itemTemplate,
      funnels:[],
      count:0,
      custom_fields:[],
      q: "",
      isappending:false,



    }
  },

  mounted: function () {

    var app = this;
      app.is_load=true;
    var q_string="";
    if(app.$route.query && app.$route.query.q && app.$route.query.q.length>0){
      q_string=app.$route.query.q;
      app.q=q_string;

    }


    Api.loadFunnels(function (datas) {
      if (datas.funnels.length > 0) {
        app.funnels = datas.funnels;
      }
    })
    app.searchLeads();








  },
  methods: {


    appendLeads(){
      var app=this;
      var text=app.q;

      app.isappending=true;
      var limit=50;
      var offset=app.leads.length;
      Api.getAllLeads(text,limit,offset,function(data){

        app.items=[];
        var leads=data.leads;
       // app.custom_fields=data.fields;
        app.count=data.count;
        app.leads=app.leads.concat(leads);





        app.isappending=false;
      },function(err_message){

      });
    },
    searchLeads(){

      var app=this;
      var text=app.q;

      var limit=50;
      var offset=0;


      Api.getAllLeads(text,limit,offset,function(data){

          app.items=[];
          var leads=data.leads;
          app.custom_fields=data.fields;
          app.count=data.count;



          app.leads=leads;


        app.is_load=true;
      },function(err_message){
        app.is_load=false;
        app.is_load_error=true;
        app.load_error=err_message;
      });
    },



  },
  components: {Modal,LoadingBlock}
};
</script>